import { defineComponent } from '@vue/composition-api';
import MyHead from './components/head.vue';
import Sign from './components/sign.vue';
import Photos from './components/photos.vue';
import Gifts from './components/gifts.vue';
import Players from './components/players.vue';
import Bottom from './components/bottom.vue';
import Draw from './components/draw.vue';
import Winners from './components/winners.vue';
import DrawVideo from './sub-components/draw-video.vue';
export default defineComponent({
  components: {
    MyHead: MyHead,
    Sign: Sign,
    Photos: Photos,
    Gifts: Gifts,
    Players: Players,
    Bottom: Bottom,
    Draw: Draw,
    Winners: Winners,
    DrawVideo: DrawVideo
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    photoList: {
      type: Array,
      required: true
    }
  },
  emits: ['change-video', 'change-players'],
  setup: function setup(props, ctx) {
    var nowTime = new Date().getTime();
    return {
      nowTime: nowTime
    };
  }
});